import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { handleLoggingIn, LoginPage } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { postAPISurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/thunks/userResponse.thunk';
import { ENVIRONMENT_URL } from '@backrs_ui/grow-ui/src/settings';
import { getBackrsToken, handleAfterLogin } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const LOGIN_STRINGS = appStrings.modules.login;

export const LoginPageContainer = () => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { user } = useAppSelector((state) => state.user);
  const { careerQuestions } = useAppSelector((state) => state.survey);
  const { careerPaths, careerPathRoles, careerPathMeanings, careerPathEnjoyments } = useAppSelector(
    (state) => state.careerPath,
  );
  const mostRecentUserResponseSet = useAppSelector(
    (state) => state.userResponseSet.mostRecentUserResponseSet,
  );

  useEffect(() => {
    const accessToken = getBackrsToken();

    if (user && accessToken) {
      navigate(APP_ROUTE.HOME);
    }
  }, [user, navigate]);

  const afterLogin = async (loginResponse: {
    access_token?: string | undefined;
    status_code?: number | undefined;
    phone?: string | undefined;
  }) => {
    if (loginResponse?.status_code === 200) {
      navigate(APP_ROUTE.OTP, { state: { phone: loginResponse.phone } });

      return;
    }

    if (loginResponse?.access_token) {
      handleAfterLogin({
        access_token: loginResponse.access_token,
        dispatch,
        navigate,
        setErrorMessage,
      });

      if (mostRecentUserResponseSet) {
        // then we know they skipped sign in, but decided to login after taking the survey
        // so we need to post the results with the thunk and then navigate to the results page

        const resultAction = await dispatch(
          postAPISurveyResults({
            userResponseSet: mostRecentUserResponseSet,
            careerQuestions,
            careerPaths,
            careerPathRoles,
            careerPathMeanings,
            careerPathEnjoyments,
          }),
        );

        if (postAPISurveyResults.fulfilled.match(resultAction)) {
          navigate(APP_ROUTE.MY_BLUEPRINT);

          return;
        }
      }
    }
  };

  const onLogin = async (phone: string, email: string, password: string) => {
    await handleLoggingIn({
      phone,
      email,
      password,
      setErrorMessage,
      environmentUrl: ENVIRONMENT_URL,
      afterLogin,
    });
  };

  return (
    <LoginPage
      title={LOGIN_STRINGS.title}
      handleLoggingIn={onLogin}
      errorMessage={errorMessage}
      environmentUrl={ENVIRONMENT_URL}
      handleSigningUp={() => navigate(APP_ROUTE.ONBOARDING)}
    />
  );
};
